import { render } from "./LoadingSpinner.vue?vue&type=template&id=8adfdf62&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=8adfdf62&scoped=true&lang=scss"

import exportComponent from "/Users/yanislav.pavlov/development/private/bulgartabac/bulgartabac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adfdf62"]])

export default __exports__